var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRepeatArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.8357 40.4762H95.2381V10.5L84.9167 20.9405C84.1071 19.9905 83.3667 19.0595 82.4857 18.1548C64.6762 0.297616 35.8857 0.297616 18.1 18.1548C0.292859 36.0119 0.326193 64.9667 18.1357 82.8238C35.9238 100.681 64.7952 100.681 82.6071 82.8238C82.6071 82.8238 88.5714 75.8262 90.5452 72.0857L80.7143 67.7048C79.2643 70.2476 75.0238 75.2 75.0238 75.2C61.4071 88.8667 39.3595 88.8667 25.7643 75.2C12.1452 61.5595 12.1476 39.4119 25.7643 25.769C39.3595 12.1024 61.4095 12.1024 75.0238 25.769C75.931 26.6738 76.7595 27.1357 77.55 28.1119L64.8357 40.4762Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeatArrow);
export default __webpack_public_path__ + "static/media/repeat-arrow.9c9400bad5ccab7c2c768a38d13a3b70.svg";
export { ForwardRef as ReactComponent };